import { Spinner } from '@nextui-org/react-latest'
import styled from '@emotion/styled'

const LoaderWrapper = styled.div<{ size: string }>`
  width: ${(props) =>
    props.size === 'large'
      ? '70px'
      : props.size === 'medium'
        ? '40px'
        : '20px'};
  height: ${(props) =>
    props.size === 'large'
      ? '70px'
      : props.size === 'medium'
        ? '40px'
        : '20px'};
`

type TLoader = {
  size?: 'small' | 'medium' | 'large'
  color?: string
}

const Loader = ({ size = 'medium', color = '' }: TLoader) => {
  const sizes = {
    small: 'sm',
    medium: 'md',
    large: 'lg',
  }
  return (
    <LoaderWrapper size={size} color={color}>
      <Spinner size={sizes[size] as 'sm'} />
    </LoaderWrapper>
  )
}

export default Loader
